export const LOAD_CANDIDATOS = 'LOAD_CANDIDATOS'
export const LOAD_VOTOS = 'LOAD_VOTOS'
export const RESET_ELEICOES = 'RESET_ELEICOES'



// WEBPACK FOOTER //
// ./src/store/modules/eleicoes_conselho/types.js